var map = {
	"./img_1.jpg": 54630,
	"./img_10.jpg": 99732,
	"./img_2.jpg": 94310,
	"./img_3.jpg": 36418,
	"./img_4.jpg": 34073,
	"./img_5.jpg": 38420,
	"./img_6.jpg": 41625,
	"./img_7.jpg": 12012,
	"./img_8.jpg": 44710,
	"./img_9.jpg": 88510
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54793;